import { Suspense } from "react";
import { ErrorBoundary } from "../components/ErrorBoundary";
import { useParams } from "wouter";
import { webTools } from "../../tools/web";
import { Notice, Spinner } from "../components/ui";
import { useCompany } from "../lib/company";

/** /t/:toolId: the tool's own component, if this person can use it here. */
export function ToolPage() {
    const { toolId } = useParams<{ toolId: string }>();
    const company = useCompany();
    const tool = webTools[toolId];
    if (!tool || !company.tools.includes(toolId)) {
        return (
            <div className="page">
                <Notice>This tool isn't available to you.</Notice>
            </div>
        );
    }
    return (
        <ErrorBoundary key={toolId}>
            <Suspense fallback={<Spinner full />}>
                <tool.Component />
            </Suspense>
        </ErrorBoundary>
    );
}
